import _extends from "@babel/runtime/helpers/esm/extends";
// Vendor Libs
import { combineReducers } from 'redux';
import { createReduxHistoryContext } from 'redux-first-history';
import { createBrowserHistory } from 'history'; // App Reducers

import { authReducer } from './auth-reducer';
import { getFormReducer } from './form-reducer';
import { getServiceReducer } from './service-reducer';
import { overlayReducer } from './overlay-reducer';
import { routerReducer } from './router-reducer';
export var reduxHistoryContext = createReduxHistoryContext({
  history: createBrowserHistory(),
  routerReducerKey: 'history'
});
var history = reduxHistoryContext.routerReducer;
export var getRootReducer = function getRootReducer(reducers, config) {
  if (reducers === void 0) {
    reducers = {};
  }

  if (config === void 0) {
    config = {};
  }

  return combineReducers(_extends({
    auth: authReducer,
    form: getFormReducer(config),
    history: history,
    overlay: overlayReducer,
    router: routerReducer,
    service: getServiceReducer(config)
  }, reducers));
};